import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { create, getOne } from '../../../../common/v4/BackendProvider';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel } from './../../../../common/EditPage';
import SelectContainer from '../../../../common/SelectContainer';

const SmsMasterCodeCreate = () => {
    const navigate = useNavigate(); 
    const [metadata, setMetadata] = useState({});
    const [data, setData] = useState({
        ATRDESTCODE: '',
        ATRNAME: '',
        ATRISOCOUNTRY: '',
        ATRSTATUS: '1'
    });
    useEffect(() => {
        getOne('/admin/products/sms_master_code_prefixes/', 'new').then(response => {
            setMetadata(response.data.metadata);
        }).catch(error => {
                toast.error("Error fetching rate profile: " + error.message, {});
        });
    }, []);

    const handleSave = () => {
        create('/admin/products/sms_master_code_prefixes', {data: data}).then(response => {
            toast.success("SMS Master Code Prefix created successfully", {});
            navigate('/products/sms_master_codes/prefixes');
        }).catch(error => {
            toast.error("Error creating SMS Master Code Prefix: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/products/sms_master_codes/prefixes');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create SMS Master Code Prefix" >
                <EditPagePanel>
                    <EditPageTextField label="Prefix" id="prefix" onChange={ onChange } value={ data.prefix } />
                    <SelectContainer label="Master Code" id="master_code_id" onChange={ onChange } value={ data.master_code_id } options={metadata?.master_codes?.values} />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}   

export default SmsMasterCodeCreate;